import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TabbedRouterView from '@/components/common/TabbedRouterView.vue';
import { ContractValidationType, ContractValidationTypeKeys } from '@/models/enums/ContractValidationType';

export default /*#__PURE__*/_defineComponent({
  __name: 'ContractValidations',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TabbedRouterView, {
    paramKey: "type",
    tabs: _unref(ContractValidationTypeKeys),
    tabDisplayMap: _unref(ContractValidationType)
  }, null, 8, ["tabs", "tabDisplayMap"]))
}
}

})